// src/Hooks/ConfirmModal.js
import React from "react";


const ConfirmModal = ({ isOpen, onConfirm, onCancel, message }) => {
  if (!isOpen) return null;

  return (
    <div className="confirm-modal-backdrop">
      <div className="confirm-modal">
        <div className="confirm-head">
          <h5 className="confirm-title">Please Confirm</h5>
          <button className="confirm-x" onClick={onCancel} aria-label="Close">
            <i className="bx bx-x"></i>
          </button>
        </div>
        <p className="confirm-message">{message}</p>
        <div className="confirm-actions">
          <button className="btn btn-confirm" onClick={onConfirm}>
            Yes, Confirm
          </button>
          <button className="btn btn-cancel" onClick={onCancel}>
            Cancel
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
